import { Component, OnInit } from "@angular/core";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CitiesService } from "../../../auth/service/cities.service";
import { UtilsService } from "../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../auth/service";
import { Router } from "@angular/router";
import { TutorialService } from "../../../auth/service/tutorial.service";
import _ from "lodash";
import nationsWithCodes from "app/auth/models/nations-with-codes";
import { ICity } from "../../../auth/models/cities";

@Component({
  selector: "app-onboarding-anagrafica",
  templateUrl: "./onboarding-anagrafica.component.html",
  styleUrls: ["./onboarding-anagrafica.component.scss"],
})
export class OnboardingAnagraficaComponent implements OnInit {
  //  Public
  public coreConfig: any;
  public formGroup: FormGroup;
  public currentUser: any;
  public avatarImage: any;
  public provinces_list: ICity[] = [];
  public fileErrorSize: boolean = false;
  public showErrors: boolean = false;
  public usedSameAddresses: boolean = false;
  public nationsWithCodes: { name: string; code: string }[] = nationsWithCodes;

  /**
   * Constructor
   * @param {UserService} _userService
   * @param {CoreConfigService} _coreConfigService
   * @param _formBuilder
   * @param {CitiesService} _citiesService
   * @param {UtilsService} _utilService
   * @param _authenticationService
   * @param _router
   * @param _tutorialService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    public _citiesService: CitiesService,
    public _utilService: UtilsService,
    private _userService: UserService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    public _tutorialService: TutorialService,
  ) {
    this._utilService.disableAutoHideLoading();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
    this.formGroup = this._formBuilder.group({
      firstname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      private_phone: new FormControl("", [Validators.required]),
      private_email: new FormControl("", [Validators.required, Validators.email]),
      residence_province: new FormControl("", [Validators.required]),
      residence_city: new FormControl("", [Validators.required]),
      residence_address: new FormControl("", [Validators.required]),
      residence_zipcode: new FormControl("", [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("[0-9]+")]),
      residence_external: new FormControl(false),
      residence_country: new FormControl(null),
      living_address: new FormControl("", [Validators.required]),
      living_zipcode: new FormControl("", [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("[0-9]+")]),
      living_city: new FormControl("", [Validators.required]),
      living_province: new FormControl("", [Validators.required]),
      living_external: new FormControl(false),
      living_country: new FormControl(null),
    });
  }

  async ngOnInit() {
    await this._citiesService.getList();
    const currentUser = this._authenticationService.getCurrentUser();
    if (currentUser && currentUser.send_onboarding === 1) {
      await this._router.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    this.currentUser = await this._userService.get(currentUser.hash);

    if (this.currentUser) {
      this.formGroup.patchValue({
        firstname: this.currentUser.firstname,
        lastname: this.currentUser.lastname,
        private_phone: this.currentUser.private_phone,
        private_email: this.currentUser.private_email,
      });
      if (this.currentUser.addresses) {
        if (this.currentUser.addresses.residenza) {
          this.formGroup.patchValue({
            residence_address: this.currentUser.addresses.residenza.street,
            residence_zipcode: this.currentUser.addresses.residenza.zipcode,
            residence_city: this.currentUser.addresses.residenza.city_id,
            residence_province: this.currentUser.addresses.residenza.province_id,
            residence_external: this.currentUser.addresses.residenza.country ? true : false,
            residence_country: this.currentUser.addresses.residenza.country,
            // working_city: this.currentUser.addresses.residenza.street,
          });
        }
        if (this.currentUser.addresses.spedizione) {
          this.formGroup.patchValue({
            living_address: this.currentUser.addresses.spedizione.street,
            living_zipcode: this.currentUser.addresses.spedizione.zipcode,
            living_city: this.currentUser.addresses.spedizione.city_id,
            living_province: this.currentUser.addresses.spedizione.province_id,
            living_external: this.currentUser.addresses.residenza.country ? true : false,
            living_country: this.currentUser.addresses.residenza.country,
          });
        }

        if (this.currentUser.addresses.residenza && this.currentUser.addresses.spedizione && _.isEqual(this.currentUser.addresses.residenza, this.currentUser.addresses.spedizione)) {
          this.usedSameAddresses = true;
        }
      }
    }

    this.provinces_list = this._citiesService.list
      .filter((city: any) => city.is_main)
      .sort((a: any, b: any) => {
        a = a.name;
        b = b.name;
        return a > b ? 1 : a < b ? -1 : 0;
      });
    this.avatarImage = this.currentUser?.avatar;
    if (this.formGroup.value.residence_external) {
      this.manageExternalSiteResidence();
    }
    if (this.formGroup.value.living_external) {
      this.manageExternalSiteLiving();
    }
    this._utilService.hideLoading();
  }

  async handlerChangeFileInput(event: any, what: string) {
    if (event.target.files && event.target.files[0].size > 10000000) {
      await this._utilService.showSWALError({ text: "ERROR_FILE_SIZE_ONBOARDING_AVATAR" });
      this.fileErrorSize = true;
      event.target.result = null;
      event.target.value = null;
      return false;
    }
    this.fileErrorSize = false;
    this._utilService.convertFileToBase64(event, (e: any) => {
      const r = e.target.result;
      switch (what) {
        case "avatar":
          this.avatarImage = r;
          break;
      }
    });
  }

  setAutoProvince(type: string) {
    const cityForm: number = this.formGroup.get(type + "_city").value;
    if (cityForm > 0) {
      const cityObj: ICity = this._citiesService.list.find((city: ICity) => city.id === cityForm);
      const province: ICity = this._citiesService.list.find((city: ICity) => city.initials === cityObj.initials && city.is_main === 1);
      if (type === "living") {
        this.formGroup.patchValue({ living_province: province.id });
      } else {
        this.formGroup.patchValue({ residence_province: province.id });
      }
    }
  }

  isDisabledSave() {
    if (!this.avatarImage) return true;
    let enableSave: boolean = true;

    Object.keys(this.formGroup.controls).map((field: string) => {
      if (this.formGroup.controls[field].invalid && enableSave) {
        enableSave = false;
      }
    });

    return !enableSave;
  }

  async copyResidence() {
    if (!this.usedSameAddresses) {
      this.formGroup.patchValue({
        living_address: this.formGroup.value.residence_address,
        living_zipcode: this.formGroup.value.residence_zipcode,
        living_city: this.formGroup.value.residence_city,
        living_province: this.formGroup.value.residence_province,
        living_country: this.formGroup.value.residence_country,
        living_external: this.formGroup.value.residence_external,
      });
    } else {
      //Resetto i valori
      this.formGroup.patchValue({
        living_address: null,
        living_zipcode: null,
        living_city: null,
        living_province: null,
        living_country: null,
      });
    }
    this.manageExternalSiteLiving();

    this.usedSameAddresses = !this.usedSameAddresses;
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async save() {
    this.showErrors = true;

    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }
    if (!this.avatarImage) {
      await this._utilService.showSWALError({ text: "FIELD_AVATAR" });
      return false;
    }

    let data = this.formGroup.value;
    let userData: any = {
      firstname: data.firstname,
      lastname: data.lastname,
      private_phone: data.private_phone,
      private_email: data.private_email,
      working_city: data.residence_city,
      addresses: {
        residenza: {
          street: data.residence_address,
          zipcode: data.residence_zipcode,
          city: data.residence_city,
          province: data.residence_province,
          country: data.residence_country,
        },
        spedizione: {
          street: data.living_address,
          zipcode: data.living_zipcode,
          city: data.living_city,
          province: data.living_province,
          country: data.living_country,
        },
      },
    };
    if (!!this.avatarImage && this.avatarImage.includes("https")) {
      this._userService
        .update(this.currentUser.hash, userData)
        .then(() => this._router.navigateByUrl("/onboarding/education"))
        .catch(() => {
          this._utilService.showSWALError({ text: "ERROR_MASTER_DATA_INSERT" });
          return false;
        });
    } else {
      return this._userService
        .uploadAvatar(this.currentUser.hash, this.avatarImage)
        .then(() => {
          this._userService
            .update(this.currentUser.hash, userData)
            .then(() => this._router.navigateByUrl("/onboarding/education"))
            .catch(() => {
              this._utilService.showSWALError({ text: "ERROR_MASTER_DATA_INSERT" });
              return false;
            });
        })
        .catch(() => {
          this._utilService.showSWALError({ text: "AVATAR_UPLOAD_ERROR" });
        });
    }
  }

  showVideo() {
    this._tutorialService.video_to_play = "Onboarding";
    this._tutorialService.force_open_modal = true;
  }

  /*In caso di sede estera città zipcode e provincia saranno impostati e inviati a null*/
  manageExternalSiteResidence() {
    if (this.formGroup.value.residence_external) {
      this.formGroup.get("residence_country").addValidators(Validators.required);
      this.formGroup.get("residence_city").clearValidators();
      this.formGroup.get("residence_zipcode").clearValidators();
      this.formGroup.get("residence_province").clearValidators();
      this.formGroup.patchValue({
        residence_province: null,
        residence_city: null,
        residence_zipcode: null,
      });
    } else {
      this.formGroup.patchValue({
        residence_country: null,
      });
      this.formGroup.get("residence_country").clearValidators();
      this.formGroup.get("residence_province").addValidators(Validators.required);
      this.formGroup.get("residence_city").addValidators(Validators.required);
      this.formGroup.get("residence_zipcode").addValidators(Validators.required);
      this.formGroup.get("residence_zipcode").addValidators(Validators.minLength(5));
      this.formGroup.get("residence_zipcode").addValidators(Validators.maxLength(5));
      this.formGroup.get("residence_zipcode").addValidators(Validators.pattern("[0-9]+"));
    }
    this.formGroup.get("residence_country").updateValueAndValidity();
    this.formGroup.get("residence_city").updateValueAndValidity();
    this.formGroup.get("residence_zipcode").updateValueAndValidity();
    this.formGroup.get("residence_province").updateValueAndValidity();
  }

  manageExternalSiteLiving() {
    if (this.formGroup.value.living_external) {
      this.formGroup.get("living_country").addValidators(Validators.required);
      this.formGroup.get("living_city").clearValidators();
      this.formGroup.get("living_zipcode").clearValidators();
      this.formGroup.get("living_province").clearValidators();
      this.formGroup.patchValue({
        living_zipcode: null,
        living_city: null,
        living_province: null,
      });
    } else {
      this.formGroup.patchValue({
        living_country: null,
      });
      this.formGroup.get("living_country").clearValidators();
      this.formGroup.get("living_province").addValidators(Validators.required);
      this.formGroup.get("living_city").addValidators(Validators.required);
      this.formGroup.get("living_zipcode").addValidators(Validators.required);
      this.formGroup.get("living_zipcode").addValidators(Validators.minLength(5));
      this.formGroup.get("living_zipcode").addValidators(Validators.maxLength(5));
      this.formGroup.get("living_zipcode").addValidators(Validators.pattern("[0-9]+"));
    }
    this.formGroup.get("living_country").updateValueAndValidity();
    this.formGroup.get("living_city").updateValueAndValidity();
    this.formGroup.get("living_zipcode").updateValueAndValidity();
    this.formGroup.get("living_province").updateValueAndValidity();
  }
}
